import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1ab9494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-table-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridRow = _resolveComponent("GridRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item) => {
        return (_openBlock(), _createBlock(_component_GridRow, {
          key: item.fieldName,
          rowData: item
        }, null, 8, ["rowData"]))
      }), 128))
    ]),
    (_ctx.modalDataPreferenceSettings.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalDataPreferenceSettings.component), {
          key: 0,
          defaultTabIdx: _ctx.modalDataPreferenceSettings.defaultTabIdx,
          hiddenTabIdx: _ctx.modalDataPreferenceSettings.hiddenTabIdx,
          fieldId: _ctx.modalDataPreferenceSettings.fieldId,
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalDataPreferenceSettings.show = false))
        }, null, 8, ["defaultTabIdx", "hiddenTabIdx", "fieldId"]))
      : _createCommentVNode("", true),
    (_ctx.modalImageViewer.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalImageViewer.component), {
          key: 1,
          imagePath: _ctx.modalImageViewer.imagePath,
          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalImageViewer.show = false))
        }, null, 8, ["imagePath"]))
      : _createCommentVNode("", true)
  ], 64))
}